import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux'
import _ from 'lodash';
import { Cascader } from 'antd';

@connect(({ app = {}, user = {}, badges = {} }) => ({ app, user, badges }))
export default class CitySelect extends Component {
  // triggerChange = changedValue => {
  //   if (onChange) {
  //     onChange({
  //       number,
  //       currency,
  //       ...value,
  //       ...changedValue,
  //     });
  //   }
  // };
  render() {
    const cityOptions = _.get(this, 'props.app.options.citys', [])
    return (
      <Fragment>
        <Cascader
          expandTrigger="hover"
          placeholder={this.props.placeholder}
          style={this.props.style}
          value={this.props.value ? [_.get(this, 'props.value.city_id'), _.get(this, 'props.value.area_id')] : undefined}
          options={cityOptions}
          fieldNames={{ label: 'name', value: 'id', children: 'children' }}
          displayRender={(labels, selectedOptions) => {
            const result = []
            
            labels.forEach((label, i) => {
              const option = selectedOptions[i];

              if (i === labels.length - 1) {
                result.splice(0, 0, <span className="text-blue"> {option.zip} </span>)
                result.push(<span key={option.value}>{label}</span>)
                return
              }

              result.push(<span key={option.value}>{label} / </span>)
            })
            
            return result
          }}
          // onChange={this.props.onChange}
          onChange={(value, selectedOptions) => {
            if (this.props.onChange) {

              this.props.onChange({
                ...this.props.value,
                city_id: _.get(value, '0'),
                area_id: _.get(value, '1'),
              })
            }
          }}
        />
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CitySelect/CitySelect.js